import { render, staticRenderFns } from "./FilterTokenHighlight.vue?vue&type=template&id=7cb7f8e4&scoped=true"
import script from "./FilterTokenHighlight.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterTokenHighlight.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterTokenHighlight.vue?vue&type=style&index=0&id=7cb7f8e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb7f8e4",
  null
  
)

export default component.exports